var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('data-table',{attrs:{"title":"Backhaul","icon":"fa fa-wifi","table-ref":"backhaultable","url":'/backhaul/site/' + _vm.rowData.id,"hide-org-badge":"","show-search":false,"fields":_vm.backhaulFields}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }